import { render, staticRenderFns } from "./ManageMyAppointments.vue?vue&type=template&id=c9f0947c&"
import script from "./ManageMyAppointments.vue?vue&type=script&lang=js&"
export * from "./ManageMyAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports